import React, { useState, useRef, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { royalcaninDogProducts } from '../Components/Assets/Product_Info/royalcaninDogProducts'
import { royalcaninCatProducts } from '../Components/Assets/Product_Info/royalcaninCatProducts'
import Carousel from '../Components/Carousel/Carousel'
import './Home.css'
import './ContactUs.css'
import cats from '../Components/Assets/front_pages/cats.jpeg'
import promoImage from '../Components/Assets/promo_images/RC_SHN_FB_Medium.jpg'

const deduplicateByBaseName = (products) => {
  const seen = new Set()
  return products.filter(p => {
    const key = p.name.replace(/\(\d+\.?\d*\s*(kg|g)\)$/, '').trim()
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}

const dogFoodProducts = deduplicateByBaseName(royalcaninDogProducts)
const catFoodProducts = deduplicateByBaseName(royalcaninCatProducts)

const stripHtml = (str) => {
  if (typeof str !== 'string') return ''
  return str.replace(/<[^>]*>/g, '').replace(/[<>]/g, '').trim()
}

const ANNOUNCEMENTS = [
  { text: 'Free Delivery on orders over R500', icon: '🚚' },
  { text: 'Premium Royal Canin nutrition for every breed', icon: '🐾' },
  { text: 'Quality guaranteed on all products', icon: '✓' },
]

// const TRUST_WIDGETS = [
//   { icon: '🚚', title: 'Free Delivery', desc: 'On orders over R500' },
//   { icon: '🔒', title: 'Secure Checkout', desc: '100% secure payment — Visa & Payfast accepted' },
// ]

const PAYMENT_METHODS_WIDGET = {
  title: 'Safe & Secure Payments',
  subtitle: 'Your trust is our priority. Every transaction is encrypted and protected.',
  methods: [
    {
      name: 'Visa',
      icon: '💳',
      desc: 'Pay securely with any Visa debit or credit card. 3D Secure authentication included.',
    },
    {
      name: 'Payfast',
      icon: '🔐',
      desc: 'South Africa’s trusted gateway — instant EFT, credit cards & more via Payfast.',
    },
  ],
  footer: 'All payments are processed via Payfast’s PCI-compliant gateway. No card details are stored on our servers.',
}

const COMMITMENT_POLICY = [
  {
    title: 'Our Commitment',
    items: [
      'We are committed to providing only genuine Royal Canin and Eukanuba products.',
      'All products are sourced directly from authorized distributors.',
      'We stand behind the quality of every product we sell.',
      'Our team is dedicated to helping you find the right nutrition for your pet.',
    ]
  },
]

const Home = () => {
  const formRef = useRef(null)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')
  const [sending, setSending] = useState(false)
  const [announcementIdx, setAnnouncementIdx] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setAnnouncementIdx(prev => (prev + 1) % ANNOUNCEMENTS.length)
    }, 4000)
    return () => clearInterval(interval)
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    const form = formRef.current
    const name = stripHtml(form.name.value)
    const email = stripHtml(form.email.value)
    const subject = stripHtml(form.subject.value)
    const message = stripHtml(form.message.value)

    if (!name || !email || !subject || !message) {
      setError('Please fill in all fields.')
      return
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address.')
      return
    }

    setSending(true)

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, subject, message }),
      })

      if (!res.ok) {
        const data = await res.json()
        throw new Error(data.error || 'Failed to send.')
      }

      setSent(true)
      form.reset()
    } catch {
      setError('Failed to send. Please try again later.')
    } finally {
      setSending(false)
    }
  }

  return (
    <div className='home-page'>
      {/* Announcement Banner */}
      <div className='announcement-bar'>
        <div className='announcement-inner'>
          {ANNOUNCEMENTS.map((a, i) => (
            <span key={i} className={`announcement-item ${i === announcementIdx ? 'active' : ''}`}>
              <span className='announcement-icon'>{a.icon}</span>
              {a.text}
            </span>
          ))}
        </div>
      </div>

      {/* Hero Carousel */}
      <section className='hero-carousel'>
        <div className='hero-carousel-content'>
          <div className='hero-text'>
            <p className='hero-badge'>ArrAndArr</p>
            <h1 className='hero-heading'>
              Premium Pet Nutrition for Your Furry Family
            </h1>
            <p className='hero-subheading'>
              South Africa's trusted source for Royal Canin pet food.
              Science-backed nutrition for every breed, age, and size.
            </p>
            <div className='hero-actions'>
              <Link to='/DogProducts' className='hero-btn hero-btn-primary'>Shop Dog Food</Link>
              <Link to='/CatProducts' className='hero-btn hero-btn-secondary'>Shop Cat Food</Link>
            </div>
          </div>
          <div className='hero-image-wrap'>
            <img src={cats} alt='Rumi & Rushdi' className='hero-image' />
          </div>
        </div>
      </section>

      {/* Product Carousels - Dog Food */}
      <section className='product-carousels'>
        <Carousel heading="Dog Food" data={dogFoodProducts} />
      </section>

      {/* Promo Banner */}
      <section className='promo-banner'>
        <img
          src={promoImage}
          alt='Special Promotion - Royal Canin'
          className='promo-image'
        />
      </section>

      {/* Trust Widgets
      <section className='trust-widgets'>
        <div className='trust-widgets-inner'>
          {TRUST_WIDGETS.map((w, i) => (
            <div key={i} className='trust-widget-card'>
              <span className='trust-widget-icon'>{w.icon}</span>
              <div className='trust-widget-text'>
                <h3>{w.title}</h3>
                <p>{w.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section> */}

      {/* Larger Payment Methods Widget */}
      <section className='payment-methods-widget'>
        <div className='payment-methods-inner'>
          <div className='payment-methods-header'>
            <span className='payment-methods-icon'>💳</span>
            <div>
              <h3>{PAYMENT_METHODS_WIDGET.title}</h3>
              <p>{PAYMENT_METHODS_WIDGET.subtitle}</p>
            </div>
          </div>
          <div className='payment-methods-grid'>
            {PAYMENT_METHODS_WIDGET.methods.map((m, i) => (
              <div key={i} className='payment-method-card'>
                <span className='payment-method-icon'>{m.icon}</span>
                <h4>{m.name}</h4>
                <p>{m.desc}</p>
              </div>
            ))}
          </div>
          <p className='payment-methods-footer'>{PAYMENT_METHODS_WIDGET.footer}</p>
        </div>
      </section>

      {/* Product Carousels - Cat Food */}
      <section className='product-carousels'>
        <Carousel heading="Cat Food" data={catFoodProducts} />
      </section>

      {/* Shop by Pet Type */}
      <section className='shop-by-pet'>
        <h2>Shop by Pet</h2>
        <div className='shop-by-pet-grid'>
          <Link to='/DogProducts' className='shop-by-pet-card'>
            <div className='shop-by-pet-icon'>🐕</div>
            <h3>Dog Products</h3>
            <p>Browse our range of premium dog food and accessories</p>
          </Link>
          <Link to='/CatProducts' className='shop-by-pet-card'>
            <div className='shop-by-pet-icon'>🐈</div>
            <h3>Cat Products</h3>
            <p>Discover quality cat food and essentials</p>
          </Link>
        </div>
      </section>

      {/* Our Mission */}
      <section className='home-mission'>
        <h2>Our Mission</h2>
        <p>
          ArrAndArr was founded to provide premium pet nutrition to South African pets.
          Every product we stock is chosen not just for quality, but for the health and happiness
          of your furry family members. We believe that caring for a pet can strengthen
          the bonds that hold us together.
        </p>
      </section>

      {/* Commitment & Refund Policy */}
      <section className='policy-section'>
        <div className='policy-grid'>
          {COMMITMENT_POLICY.map((section, i) => (
            <div key={i} className='policy-card'>
              <h3>{section.title}</h3>
              <ul>
                {section.items.map((item, j) => (
                  <li key={j}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* Contact Form */}
      <section className='home-contact'>
        <div className='contact-form-wrapper'>
          {sent ? (
            <div className='contact-success'>
              <h2>Thank you!</h2>
              <p>Your message has been sent. We will get back to you as soon as possible.</p>
            </div>
          ) : (
            <form className='contact-form' ref={formRef} onSubmit={handleSubmit}>
              <h2>Get in Touch</h2>
              <p className='contact-subtitle'>Have a question? We'd love to hear from you.</p>

              <div className='contact-form-row'>
                <div className='contact-form-field'>
                  <label htmlFor='home-name'>Name</label>
                  <input id='home-name' name='name' type='text' placeholder='Your name' required />
                </div>
                <div className='contact-form-field'>
                  <label htmlFor='home-email'>Email</label>
                  <input id='home-email' name='email' type='email' placeholder='your@email.com' required />
                </div>
              </div>

              <label htmlFor='home-subject'>Subject</label>
              <input id='home-subject' name='subject' type='text' placeholder='What is this about?' required />

              <label htmlFor='home-message'>Message</label>
              <textarea id='home-message' name='message' placeholder='Your message...' required />

              {error && <p className='contact-error'>{error}</p>}

              <button type='submit' disabled={sending} className='contact-submit'>
                {sending ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          )}
        </div>
      </section>
    </div>
  )
}

export default Home
